import { BasicWithLibelleModel } from '../basic/basicWithLibelle.model';
import { BasicModel } from "../basic/basic.model";

export class DocumentModel extends BasicModel implements BasicWithLibelleModel {
    // max length 15
    code: string;
    // max length 80
    libelle: string;

    idBp?: number;

    idBc?: number;
}
